import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-bg-section border-t border-text-secondary/10 py-8 md:py-12 px-4" data-id="element-54">
        <div className="max-w-7xl mx-auto" data-id="element-55">
          <div className="text-center space-y-4 md:space-y-6" data-id="element-56">
            <div data-id="element-57">
              <h3 className="text-xl md:text-2xl font-bold text-cta mb-2" data-id="element-58">
                EMPRENDE USA EXPRESS
              </h3>
              <p className="text-sm md:text-base text-text-secondary" data-id="element-59">
                La Guía Maestra para registrar, estructurar y dominar tu propia
                empresa viviendo en USA
              </p>
            </div>

            <div className="flex items-center justify-center gap-4 md:gap-6 text-xs md:text-sm" data-id="element-60">
              <button onClick={() => setShowPrivacy(true)} className="text-text-secondary hover:text-cta transition-colors" data-id="element-61">
                Privacy Policy
              </button>
              <span className="text-text-secondary/30" data-id="element-62">•</span>
              <button onClick={() => setShowTerms(true)} className="text-text-secondary hover:text-cta transition-colors" data-id="element-63">
                Terms of Service
              </button>
            </div>

            <div className="pt-4 md:pt-6 border-t border-text-secondary/10" data-id="element-64">
              <p className="text-text-secondary text-xs md:text-sm" data-id="element-65">
                © {new Date().getFullYear()} EMPRENDE USA EXPRESS. Todos los
                derechos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-66">
          <div className="bg-bg-card max-w-3xl w-full max-h-[90vh] overflow-y-auto rounded-xl border border-text-secondary/20" data-id="element-67">
            <div className="sticky top-0 bg-bg-card border-b border-text-secondary/20 p-4 md:p-6 flex items-center justify-between" data-id="element-68">
              <h2 className="text-xl md:text-2xl font-bold" data-id="element-69">Privacy Policy</h2>
              <button onClick={() => setShowPrivacy(false)} className="text-text-secondary hover:text-white transition-colors" aria-label="Close" data-id="element-70">
                <XIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-71" />
              </button>
            </div>
            <div className="p-4 md:p-6 space-y-4 md:space-y-6 text-text-secondary leading-relaxed text-sm md:text-base" data-id="element-72">
              <p className="text-xs md:text-sm text-text-secondary/70" data-id="element-73">
                Última actualización: {new Date().toLocaleDateString('es-ES')}
              </p>

              <section data-id="element-74">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-75">
                  1. Información que Recopilamos
                </h3>
                <p data-id="element-76">
                  Cuando adquieres EMPRENDE USA EXPRESS, recopilamos información
                  necesaria para procesar tu compra y entregarte el producto
                  digital, incluyendo nombre, dirección de correo electrónico e
                  información de pago.
                </p>
              </section>

              <section data-id="element-77">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-78">
                  2. Uso de la Información
                </h3>
                <p data-id="element-79">Utilizamos tu información para:</p>
                <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-80">
                  <li data-id="element-81">Procesar tu compra y entregarte el ebook</li>
                  <li data-id="element-82">Enviar confirmación de compra y acceso al producto</li>
                  <li data-id="element-83">Proporcionar soporte al cliente</li>
                  <li data-id="element-84">Cumplir con obligaciones legales</li>
                </ul>
              </section>

              <section data-id="element-85">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-86">
                  3. Protección de Datos
                </h3>
                <p data-id="element-87">
                  Implementamos medidas de seguridad apropiadas para proteger tu
                  información personal contra acceso no autorizado, alteración,
                  divulgación o destrucción. Los pagos son procesados a través
                  de plataformas seguras de terceros.
                </p>
              </section>

              <section data-id="element-88">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-89">
                  4. Compartir Información
                </h3>
                <p data-id="element-90">
                  No vendemos, intercambiamos ni transferimos tu información
                  personal a terceros, excepto cuando sea necesario para
                  procesar tu compra (procesadores de pago) o cuando lo requiera
                  la ley.
                </p>
              </section>

              <section data-id="element-91">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-92">
                  5. Cookies
                </h3>
                <p data-id="element-93">
                  Utilizamos cookies esenciales para el funcionamiento del sitio
                  web y para mejorar tu experiencia de usuario.
                </p>
              </section>

              <section data-id="element-94">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-95">
                  6. Tus Derechos
                </h3>
                <p data-id="element-96">
                  Tienes derecho a acceder, corregir o eliminar tu información
                  personal. Para ejercer estos derechos, contáctanos a través de
                  los canales disponibles.
                </p>
              </section>

              <section data-id="element-97">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-98">
                  7. Cambios a esta Política
                </h3>
                <p data-id="element-99">
                  Nos reservamos el derecho de actualizar esta política de
                  privacidad en cualquier momento. Los cambios serán efectivos
                  inmediatamente después de su publicación en esta página.
                </p>
              </section>
            </div>
          </div>
        </div>}

      {/* Terms of Service Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4" data-id="element-100">
          <div className="bg-bg-card max-w-3xl w-full max-h-[90vh] overflow-y-auto rounded-xl border border-text-secondary/20" data-id="element-101">
            <div className="sticky top-0 bg-bg-card border-b border-text-secondary/20 p-4 md:p-6 flex items-center justify-between" data-id="element-102">
              <h2 className="text-xl md:text-2xl font-bold" data-id="element-103">
                Terms of Service
              </h2>
              <button onClick={() => setShowTerms(false)} className="text-text-secondary hover:text-white transition-colors" aria-label="Close" data-id="element-104">
                <XIcon className="w-5 h-5 md:w-6 md:h-6" data-id="element-105" />
              </button>
            </div>
            <div className="p-4 md:p-6 space-y-4 md:space-y-6 text-text-secondary leading-relaxed text-sm md:text-base" data-id="element-106">
              <p className="text-xs md:text-sm text-text-secondary/70" data-id="element-107">
                Última actualización: {new Date().toLocaleDateString('es-ES')}
              </p>

              <section data-id="element-108">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-109">
                  1. Aceptación de Términos
                </h3>
                <p data-id="element-110">
                  Al adquirir EMPRENDE USA EXPRESS, aceptas estos Términos de
                  Servicio. Si no estás de acuerdo con estos términos, no debes
                  realizar la compra.
                </p>
              </section>

              <section data-id="element-111">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-112">
                  2. Descripción del Producto
                </h3>
                <p data-id="element-113">
                  EMPRENDE USA EXPRESS es un producto digital educativo en
                  formato PDF que proporciona información y guía sobre el
                  proceso de registro, estructuración y operación de empresas en
                  Estados Unidos.
                </p>
              </section>

              <section data-id="element-114">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-115">
                  3. Naturaleza del Producto
                </h3>
                <p data-id="element-116">
                  Este es un producto educativo e informativo. No garantizamos
                  resultados financieros específicos, ingresos, o éxito
                  empresarial. Los resultados dependen de múltiples factores
                  fuera de nuestro control.
                </p>
              </section>

              <section data-id="element-117">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-118">
                  4. Licencia de Uso
                </h3>
                <p data-id="element-119">
                  Al adquirir el ebook, recibes una licencia personal, no
                  transferible, para uso individual. Está prohibido:
                </p>
                <ul className="list-disc list-inside mt-2 space-y-1 ml-4" data-id="element-120">
                  <li data-id="element-121">Compartir, distribuir o revender el contenido</li>
                  <li data-id="element-122">Reproducir o copiar el material para uso comercial</li>
                  <li data-id="element-123">Modificar o crear obras derivadas</li>
                  <li data-id="element-124">Transferir tu licencia a terceros</li>
                </ul>
              </section>

              <section data-id="element-125">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-126">
                  5. Propiedad Intelectual
                </h3>
                <p data-id="element-127">
                  Todo el contenido de EMPRENDE USA EXPRESS, incluyendo texto,
                  gráficos, diseño y estructura, está protegido por derechos de
                  autor y es propiedad exclusiva del creador.
                </p>
              </section>

              <section data-id="element-128">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-129">
                  6. Política de Reembolsos
                </h3>
                <p data-id="element-130">
                  Debido a la naturaleza digital del producto y el acceso
                  inmediato al contenido completo, todas las ventas son finales.
                  No se ofrecen reembolsos después de la descarga.
                </p>
              </section>

              <section data-id="element-131">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-132">
                  7. Descargo de Responsabilidad
                </h3>
                <p data-id="element-133">
                  El contenido se proporciona "tal cual" con fines educativos.
                  No constituye asesoría legal, fiscal o financiera profesional.
                  Recomendamos consultar con profesionales calificados para tu
                  situación específica.
                </p>
              </section>

              <section data-id="element-134">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-135">
                  8. Limitación de Responsabilidad
                </h3>
                <p data-id="element-136">
                  No seremos responsables por daños directos, indirectos,
                  incidentales o consecuentes que resulten del uso o la
                  imposibilidad de usar este producto.
                </p>
              </section>

              <section data-id="element-137">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-138">
                  9. Modificaciones
                </h3>
                <p data-id="element-139">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. El uso continuado del producto después de
                  cambios constituye aceptación de los nuevos términos.
                </p>
              </section>

              <section data-id="element-140">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3" data-id="element-141">
                  10. Ley Aplicable
                </h3>
                <p data-id="element-142">
                  Estos términos se rigen por las leyes de Estados Unidos.
                  Cualquier disputa se resolverá en las cortes competentes de la
                  jurisdicción aplicable.
                </p>
              </section>
            </div>
          </div>
        </div>}
    </>;
}